import React, { useEffect, useState } from "react";
import "accountOwner/pages/Scheduler/components/SchedulerFilters/SchedulerFilters.scss";
import { useSelector } from "react-redux";
import {
  useAssignedStaffList,
  useAssignorList,
} from "repositories/office-policy-management-repository";
import { useQueryClient } from "react-query";

function StaffFilter({
  setStaffFilter,
  seletedStaff,
  t,
  isStaff = false,
  accountOwnerId = null,
}) {
  const queryClient = useQueryClient();
  const { data: staffListData, refetch } = useAssignedStaffList(
    accountOwnerId,
    isStaff,
    { enabled: !isStaff },
  );
  const { data: assigneeStaffListData } = useAssignorList(accountOwnerId, {
    enabled: isStaff,
  });
  const profile = useSelector((state) => state.userProfile.profile);
  const rawData = isStaff ? assigneeStaffListData : staffListData;
  const data = Array.isArray(rawData)
    ? rawData
    : rawData?.data != null && Array.isArray(rawData.data)
      ? rawData.data
      : [];
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (isStaff) {
      queryClient.invalidateQueries([
        "/PolicyAssignmentFilter/PolicyOwners",
        accountOwnerId ?? null,
      ]);
      return;
    }
    queryClient.invalidateQueries([
      "/officePolicies/AssignedStaffList",
      accountOwnerId,
    ]);
    refetch();
  }, [accountOwnerId, refetch, queryClient, isStaff]);

  useEffect(() => {
    setSelectAll(seletedStaff?.length === data?.length);
  }, [seletedStaff, data]);

  const getDisplayName = (item) => {
    if (!item) return "";
    if (item.firstName != null || item.lastName != null) {
      return `${item.firstName ?? ""} ${item.lastName ?? ""}`.trim();
    }
    return (
      item.name ?? item.userName ?? item.assignorName ?? String(item.id ?? "")
    );
  };

  const handleChange = (e, item) => {
    const staffs = [...seletedStaff];
    const staffIndex = staffs?.findIndex((v) => +item.id === +v);
    if (e.target.checked) {
      staffs.push(item.id);
    } else if (staffIndex > -1) {
      staffs.splice(staffIndex, 1);
    }
    setStaffFilter(staffs);
  };

  const handleAllChange = (e) => {
    setSelectAll(e.target.checked);
    setStaffFilter(
      e.target.checked && data?.length ? data.map((item) => item.id) : [],
    );
  };

  //Intentionally comment the code (Need clarification about can loggedIn user assign the policy to itself)
  // const list = data?.filter((d) => profile?.id !== d?.id) || [];

  return (
    <ul className={["filter-list"]}>
      {data?.length > 0 && (
        <>
          <li>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={handleAllChange}
                  checked={selectAll}
                />
                <span>{t("taskManagement.allStaff")}</span>
              </label>
            </div>
          </li>
          <hr className="mr-4" />
        </>
      )}
      {data?.map((item, key) => (
        <li key={item?.id ?? key}>
          <div className="ch-checkbox">
            <label>
              <input
                type="checkbox"
                onChange={(e) => handleChange(e, item)}
                checked={seletedStaff?.includes(item.id)}
              />
              <span> {getDisplayName(item)}</span>
            </label>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default StaffFilter;
